// extracted by mini-css-extract-plugin
module.exports = {"textInput":"UVAppBrowserItem_textInput__wA7ab"};